export default __webpack_public_path__ + "static/media/eye.839b2f73.svg";